import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { TokenServiceService } from './token-service.service';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MoneyPolicyService {

  constructor(private readonly http: HttpClient,
    private readonly tokenService: TokenServiceService) { }


  public getMoneySrcPolicy(Intoken: string) {
    const httpHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: 'bearer ' + Intoken,
      }),
    };

    return this.http.get(
      `${environment.urlglobal_api}/services/services/getMoneySourcePolicy`,
      httpHeaders
    );
  }

  public saveAcceptanceMoneySrcPolicy() {
    const token = this.tokenService.getToken();
    const body = {checkbox: true};
    const httpHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: 'bearer ' + token,
      }),
    };

    return this.http.post(
      `${environment.urlglobal_api}/services/services/acceptMoneySourcePolicy`,
      body,
      httpHeaders
    );
  }

}
